/**
 * Mobile Shop Dropdown - BarknBrew Custom Header
 * Creates a "Shop" text button next to the hamburger and a vertical grid dropdown
 * that mirrors the desktop mega menu content.
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var megaMenu = document.querySelector('.custom-header__mega-menu-inner');
    var headerContainer = document.querySelector('.custom-header__container');
    var mobileNav = document.querySelector('.custom-header__mobile-nav');
    var mobileLinks = document.querySelector('.custom-header__mobile-nav-links');
    if (!megaMenu || !headerContainer) return;

    var hamburger = document.querySelector('.custom-header__menu-toggle');
    if (!hamburger) return;

    // --- 1. Create right-side group: Shop button + hamburger ---
    var rightGroup = document.createElement('div');
    rightGroup.className = 'custom-header__right-group';

    // Insert the group where hamburger currently is
    hamburger.parentNode.insertBefore(rightGroup, hamburger);

    // Move hamburger into the group
    rightGroup.appendChild(hamburger);

    // Create Shop text button and prepend it before hamburger in the group
    var shopBtn = document.createElement('button');
    shopBtn.className = 'custom-header__shop-toggle';
    shopBtn.setAttribute('aria-label', 'Shop');
    shopBtn.setAttribute('aria-expanded', 'false');
    shopBtn.innerHTML = 'Shop <svg class="custom-header__shop-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    rightGroup.insertBefore(shopBtn, hamburger);

    // --- 2. Create dropdown panel ---
    var dropdown = document.createElement('div');
    dropdown.className = 'custom-header__shop-dropdown';

    var inner = document.createElement('div');
    inner.className = 'custom-header__shop-dropdown-inner';

    // Clone columns from desktop mega menu
    megaMenu.querySelectorAll('.custom-header__mega-menu-column').forEach(function(col) {
      var colDiv = document.createElement('div');
      colDiv.className = 'custom-header__mobile-shop-column';

      var title = col.querySelector('.custom-header__mega-menu-title');
      if (title) {
        var h4 = document.createElement('h4');
        h4.className = 'custom-header__mobile-shop-heading';
        var chevronSvg = '<svg class="custom-header__mobile-shop-heading-chevron" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 1L5.5 4L2 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        h4.innerHTML = title.innerHTML + ' ' + chevronSvg;
        colDiv.appendChild(h4);
      }

      var links = col.querySelectorAll('.custom-header__mega-menu-link');
      if (links.length > 0) {
        var ul = document.createElement('ul');
        ul.className = 'custom-header__mobile-shop-links';
        links.forEach(function(link) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = link.href;
          a.textContent = link.textContent;
          li.appendChild(a);
          ul.appendChild(li);
        });
        colDiv.appendChild(ul);
      }

      inner.appendChild(colDiv);
    });

    dropdown.appendChild(inner);

    // Insert dropdown inside the header element
    var header = document.querySelector('.custom-header');
    if (header) {
      header.appendChild(dropdown);
    }

    // --- Accordion toggle for catalogue headings ---
    inner.querySelectorAll('.custom-header__mobile-shop-heading').forEach(function(heading) {
      var linksList = heading.nextElementSibling;
      heading.addEventListener('click', function() {
        var expanded = heading.classList.contains('is-expanded');
        // Collapse all first
        inner.querySelectorAll('.custom-header__mobile-shop-heading').forEach(function(h) {
          h.classList.remove('is-expanded');
        });
        inner.querySelectorAll('.custom-header__mobile-shop-links').forEach(function(ul) {
          ul.classList.remove('is-expanded');
        });
        // Toggle clicked one
        if (!expanded && linksList && linksList.classList.contains('custom-header__mobile-shop-links')) {
          heading.classList.add('is-expanded');
          linksList.classList.add('is-expanded');
        }
      });
    });

    // --- 3. Toggle logic ---
    var isOpen = false;
    shopBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      isOpen = !isOpen;
      dropdown.classList.toggle('is-open', isOpen);
      shopBtn.classList.toggle('is-active', isOpen);
      shopBtn.setAttribute('aria-expanded', isOpen);

      // Close hamburger mobile nav if open
      if (isOpen && mobileNav && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        header.classList.remove('menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });

    // Close shop dropdown when hamburger is opened
    hamburger.addEventListener('click', function() {
      if (isOpen) {
        isOpen = false;
        dropdown.classList.remove('is-open');
        shopBtn.classList.remove('is-active');
        shopBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (isOpen && !dropdown.contains(e.target) && !shopBtn.contains(e.target)) {
        isOpen = false;
        dropdown.classList.remove('is-open');
        shopBtn.classList.remove('is-active');
        shopBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // --- 4. Remove Shop and Details links from hamburger mobile nav ---
    if (mobileLinks) {
      mobileLinks.querySelectorAll('.custom-header__mobile-link').forEach(function(link) {
        var text = link.textContent.trim().toLowerCase();
        if (text === 'shop' || text === 'details' || text.indexOf('detail') !== -1) {
          link.remove();
        }
      });
      // Also remove any stray <details> elements inside the mobile nav
      mobileNav.querySelectorAll('details').forEach(function(d) { d.remove(); });
    }
  });
})();
